@if ({
  invoiceDetails: invoiceDetails$ | async,
  errorDetails: errorDetails$ | async
  }; as type) {
  @if (invoiceDetails) {
    <div class="row">
      <div class="col-md-3 balanceTitle">
        <p>{{ 'customUserPayments.details.invoiceTitle' | cxTranslate }}</p>
      </div>
      <div class="col-md-3">
        <p>{{ invoiceDetails.invoiceNumber }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 balanceTitle">
        <p>{{ 'customUserPayments.details.invoiceDate' | cxTranslate }}</p>
      </div>
      <div class="col-md-3">
        <p>{{ invoiceDetails.formattedInvoiceDate }}</p>
      </div>
    </div>
  }
  <div class="form-group row">
    <div class="col-sm-6">
      @if (!errorDetails) {
        <button
          class="btn btn-secondary btn-block mb-3"
          type="button"
          (click)="onExport()"
          >
          {{ 'customUserPayments.buttons.exportOnly' | cxTranslate }}
        </button>
      }
    </div>
    <div class="col-sm-6">
      <button
        class="btn btn-secondary btn-block mb-3"
        type="button"
        (click)="goToUserPayments()"
        >
        {{ 'customUserPayments.buttons.back' | cxTranslate }}
      </button>
    </div>
  </div>
  @if (invoiceDetails || errorDetails) {
    <!-- TABLE -->
    <table class="table user-payments-details-table">
      <thead class="user-payments-details-thead-mobile">
        <th scope="col" class="deliveryNote">
          {{ 'customUserPayments.details.deliveryNote' | cxTranslate }}
        </th>
        <th scope="col" class="ourOrder">
          {{ 'customUserPayments.details.ourOrder' | cxTranslate }}
        </th>
        <th scope="col" class="orderDate">
          {{ 'customUserPayments.details.orderDate' | cxTranslate }}
        </th>
        <th scope="col" class="valueDate">
          {{ 'customUserPayments.details.valueDate' | cxTranslate }}
        </th>
        <th scope="col" class="address">
          {{ 'customUserPayments.details.address' | cxTranslate }}
        </th>
        <th scope="col" class="totalAmount">
          {{ 'customUserPayments.details.totalAmount' | cxTranslate }}
        </th>
        <th scope="col" class="netAmount">
          {{ 'customUserPayments.details.netAmount' | cxTranslate }}
        </th>
        <th scope="col" class="tax">
          {{ 'customUserPayments.details.tax' | cxTranslate }}
        </th>
        <th scope="col" class="boxing">
          {{ 'customUserPayments.details.boxing' | cxTranslate }}
        </th>
        <th scope="col" class="shipment">
          {{ 'customUserPayments.details.shipment' | cxTranslate }}
        </th>
      </thead>
      <tbody>
        @if (entries && entries.length === 0) {
          <tr>
            <td class="emptyTable" colspan="13">
              {{  'customUserPayments.emptyTable' | cxTranslate }}
            </td>
          </tr>
        }
        @for (entry of entries; track entry) {
          <tr>
            <!--Delivery Note-->
            <td class="deliveryNote">
              <div class="col-6 d-md-none user-payments-details-label">
                {{ 'customUserPayments.details.deliveryNote' | cxTranslate }}
              </div>
              <div class="user-payments-details-value">
                <a
                      [routerLink]="
                      {
                          cxRoute: 'deliveryNoteDetails',
                          params: { deliveryNumber: entry?.delivery }
                      } | cxUrl
                      "
                  [state]="{data:{id: entry?.delivery}}"
                  class="user-payments-details-value">
                  {{ entry?.delivery }}
                </a>
              </div>
            </td>
            <!--Our Order-->
            <td class="ourOrder">
              <div class="col-6 d-md-none user-payments-details-label">
                {{ 'customUserPayments.details.ourOrder' | cxTranslate }}
              </div>
              <div class="user-payments-details-value">
                <a
                    [routerLink]="
                    {
                        cxRoute: 'orderDetails',
                        params: { code: entry?.sales }
                    } | cxUrl
                    "
                  class="user-payments-details-value">
                  {{ entry?.sales }}
                </a>
              </div>
            </td>
            <!--Order Date-->
            <td class="orderDate">
              <div class="col-6 d-md-none user-payments-details-label">
                {{ 'customUserPayments.details.orderDate' | cxTranslate }}
              </div>
              <div class="user-payments-details-value">
                {{ entry?.formattedReceivedDate }}
              </div>
            </td>
            <!--Value Date-->
            <td class="valueDate">
              <div class="col-6 d-md-none user-payments-details-label">
                {{ 'customUserPayments.details.valueDate' | cxTranslate }}
              </div>
              <div class="user-payments-details-value">
                {{ entry?.formattedValueDate }}
              </div>
            </td>
            <!--Address-->
            <td class="address">
              <div class="col-6 d-md-none user-payments-details-label">
                {{ 'customUserPayments.details.address' | cxTranslate }}
              </div>
              <div class="user-payments-details-value">
                @if (entry?.title) {
                  {{ entry?.title }} <br>
                }
                @if (entry?.name1) {
                  {{ entry?.name1 }} <br>
                }
                @if (entry?.name2) {
                  {{ entry?.name2 }} <br>
                }
                @if (entry?.name3) {
                  {{ entry?.name3 }} <br>
                }
                @if (entry?.name4) {
                  {{ entry?.name4 }} <br>
                }
                @if (entry?.street) {
                  {{ entry.street }}
                  &nbsp;
                  {{ entry.houseNumber }}
                  &nbsp;
                  {{ entry.houseNumberSupplement }}
                  <br>
                  }
                  @if (entry?.poxBoxPostalCode) {
                    {{ entry?.poxBoxPostalCode }} <br>
                  }
                  @if (entry?.companyPostalCode) {
                    {{ entry?.companyPostalCode }} <br>
                  }
                  @if (entry?.postalCode) {
                    {{ entry.postalCode }}
                    &nbsp;
                    {{ entry.city}}
                    <br>
                    }
                    @if (entry?.district) {
                      {{ entry?.district }} <br>
                    }
                  </div>
                </td>
                <!--Total Amount-->
                <td class="totalAmount">
                  <div class="col-6 d-md-none user-payments-details-label">
                    {{ 'customUserPayments.details.totalAmount' | cxTranslate }}
                  </div>
                  <div class="user-payments-details-value">
                    {{ entry?.grossValuePriceData.value }}
                    <br>
                      {{ 'customUserPayments.details.discount1' | cxTranslate }}
                      &nbsp;
                      {{ entry?.formattedCondition1Value }}%
                      &nbsp;
                      {{ entry?.formattedRate1 }}
                      <br>
                        {{ 'customUserPayments.details.discount2' | cxTranslate }}
                        &nbsp;
                        {{ entry?.formattedCondition2Value }}%
                        &nbsp;
                        {{ entry?.formattedRate2 }}
                      </div>
                    </td>
                    <!--Net Amount-->
                    <td class="netAmount">
                      <div class="col-6 d-md-none user-payments-details-label">
                        {{ 'customUserPayments.details.netAmount' | cxTranslate }}
                      </div>
                      <div class="user-payments-details-value">
                        {{ entry?.netValuePriceData.formattedValue }}
                      </div>
                    </td>
                    <!--Tax-->
                    <td class="tax">
                      <div class="col-6 d-md-none user-payments-details-label">
                        {{ 'customUserPayments.details.tax' | cxTranslate }}
                      </div>
                      <div class="user-payments-details-value">
                        {{ entry?.formattedTaxAmount }}
                      </div>
                    </td>
                    <!--Boxing-->
                    <td>
                      <div class="col-6 d-md-none user-payments-details-label">
                        {{ 'customUserPayments.details.boxing' | cxTranslate }}
                      </div>
                      <div class="user-payments-details-value">
                        &nbsp;
                      </div>
                    </td>
                    <!--Shipment-->
                    <td class="shipment">
                      <div class="col-6 d-md-none user-payments-details-label">
                        {{ 'customUserPayments.details.shipment' | cxTranslate }}
                      </div>
                      <div class="user-payments-details-value">
                        {{ entry?.formattedConditionValue }}
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          } @else {
            <cx-spinner></cx-spinner>
          }
        }